import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { init } from './core/init';
import less from 'less';
import './index.scss';

const worker = new Worker(`${process.env.PUBLIC_URL}/events.worker.js`);
init();

const App = lazy(() => import('./App'));

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div />}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

export { worker };
